import { FormHelperText, InputLabel, OutlinedInput, OutlinedInputProps, Stack, StackProps } from "@mui/material";
import { ChangeEvent, FC, KeyboardEvent, useEffect } from "react";
import { GetFieldIsValidAndErrorMessage, DeleteField } from "../../../Redux/Reducers/redux-slice-form-validation";
import { useAppDispatch, useAppSelector } from "../../../Redux/redux-store";
import CommonValidatorProps from "../../../Utils/Hooks/Validators/commonProps";
import useTextValidator from "../../../Utils/Hooks/Validators/useTextValidator";

interface EmailValidatorProps extends CommonValidatorProps<string> {
  required?: boolean;
  initialValue?: string;
}

interface FormInputEmailProps extends Omit<OutlinedInputProps, "id" | "label" | "error" | "type"> {
  label?: string;
  validationProps: EmailValidatorProps;
  stackProps: StackProps;
}

const FormInputEmail: FC<FormInputEmailProps> = (props) => {
  const { label, validationProps, onChange, onKeyDown, stackProps, ...otherProps } = props;
  const dispatch = useAppDispatch();

  const validateText = useTextValidator({
    ...validationProps,
    regexPattern:
      // RFC2822 => https://regexr.com/3e48o
      /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g,
  });

  const errorMessage = useAppSelector(GetFieldIsValidAndErrorMessage(validationProps.formId, validationProps.fieldId));
  const isValid = !errorMessage;

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    validateText(event.target.value);
    onChange && onChange(event);
  };

  const handleOnKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    isValid && onKeyDown && onKeyDown(event);
  };

  useEffect(() => {
    return () => {
      dispatch(
        DeleteField({
          formId: validationProps.formId,
          formSectionId: validationProps.formSectionId,
          fieldId: validationProps.fieldId,
        })
      );
    };
  }, []);
  return (
    <Stack {...stackProps}>
      {label && (
        <InputLabel sx={{ mb: 1 }} htmlFor={`${validationProps.fieldId}-label`} required={validationProps.required}>
          {label}
        </InputLabel>
      )}
      <OutlinedInput
        id={validationProps.fieldId}
        onChange={handleOnChange}
        onKeyDown={handleOnKeyDown}
        type="email"
        error={!isValid}
        {...otherProps}
      />
      {!isValid && <FormHelperText error>{errorMessage}</FormHelperText>}
    </Stack>
  );
};

export default FormInputEmail;
